// table-cell — default skin module (RUN-407: native table redesign)
// Cell content is projected into native <td> elements in run-table's shadow DOM
// via manual slot assignment. role="cell" is removed — the native <td> provides it.
// This skin renders the visual content container; :host is a transparent pass-through.

export const styles = `
  :host {
    display: contents;
  }

  [part="base"] {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding-block: var(--_run-table-cell-padding-v, var(--run-space-semantic-sm));
    padding-inline: var(--_run-table-cell-padding-h, var(--run-space-semantic-md));
    font-size: var(--_run-table-font-size, var(--run-font-size-sm));
    text-align: var(--_run-table-cell-align, start);
    justify-content: var(--_run-table-cell-align, start);
  }
`;

export function render(host) {
  host.shadowRoot.innerHTML = `<div part="base"><slot></slot></div>`;
}
